const WIX_CHAT = '14517e1a-3ff0-af98-408e-2bd6953c36a2'
const WIX_AI_ASSISTANT = '31ceda3c-e2c8-4e83-816d-ba293597730c'
const PERF_CATEGORY = {category: 'tpa'}

export default {
    PERF_CATEGORY,
    PERMITTED_GLUED_TPAS_IN_MOBILE: [WIX_CHAT, WIX_AI_ASSISTANT],
    PERMITTED_FULL_SCREEN_TPAS_IN_MOBILE: [WIX_CHAT]
}
